import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist();

export const modulesAtom = atom({
	key: "modulesAtom",
	default: [],
	effects_UNSTABLE: [persistAtom],
});
